module.exports = __webpack_public_path__ + "static/img/ny-04-ABOUT.3e59f84e.jpg";